import React from 'react'
const Map = () => (
    <iframe
        width="100%"
        height="100%"
        frameBorder="0" style={{border: 0}}
        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyB1tjIl45X8DveBfJ2sxMpsfxqWFy01HXI
    &q=SarkariZone+(Study+Point+%26+Library)`} allowFullScreen>
    </iframe>
)

export default Map